import React, { useState } from 'react'

import styled from 'styled-components'


export const ButtonContainer = styled.div`
	position: fixed;
  bottom: 20px;
  right: 30px;
  padding: 12px;
  background-color: var(--orange-peel);
  color: var(--white);
  border-radius: 50%;
	height: 4.5rem;
	font-size: 22px;
	z-index: 1;
	cursor: pointer;
  transition: var(--transition-1);
	}
`

function BackToTop() {
	const [visible, setVisible] = useState(false)

	const toggleVisible = () => {
		const scrolled = document.documentElement.scrollTop
		if (scrolled > 150) {
			setVisible(true)
		} else if (scrolled <= 300) {
			setVisible(false)
		}
	}

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
	}

	window.addEventListener('scroll', toggleVisible)

	return (
  		<>
			<ButtonContainer onClick={scrollToTop} style={{ display: visible ? 'inline' : 'none' }}>
			<ion-icon name="arrow-up"></ion-icon>
      </ButtonContainer>
  		</>

	)
}

export default BackToTop
